"use strict";

$.widget("fotobook.plainTextLineHeightWidget", $.fotobook.lineHeightBaseWidget, {
    _create: function(){
        this._super();
        this.caption = this.options.editorWidget.caption;
    },
    _getTextContent: function(){
        return this.options.editorWidget._getTextContent();
    },
    _getCaption: function(){
        return this._getTextContent().closest(".caption");
    },
    _getValueFromProject: function(){
        return this._getTextContent().attr("data-line-height") || this._getDefaultValue();
    },

    _setPreviewStyle: function(lineHeight){
        this._getTextContent().css("line-height", lineHeight).attr("data-line-height", lineHeight);
        this._getTextContent().children().css("line-height", lineHeight);
        this._focusTextContent();
    },
    _removePreviewStyle: function(lineHeight){
        this._setPreviewStyle(lineHeight);
    },

    _focusTextContent: function(){
        var widget = this;
        if (document.activeElement !== this.input[0]){
            setTimeout(function(){
                widget._getTextContent().focus();
            }, 0);
        }
    },

    _changeLineHeight: function(){
        this._getTextContent().trigger("keyup");
    },

    _getDefaultValue: function (){
        return parseFloat(this._getCaption().attr('data-line-height') / 100).toFixed(2);
    },
});

